import { get } from 'lodash';
import { DocumentationDeliveryMethod } from '@lendi/core-constants';

import { FIELD_PATHS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { BrokerInterviewsGuarantorEntityIndex } from '@funnels/types';

import { FunnelGrid, FunnelGridUnit } from '../../../Common';
import { RadioButtonsField } from '../../../Fields';

export const OPTIONS = [
  {
    label:
      'Via email (email address must not be shared with the borrower, please complete the Guarantor Document Electronic Communication Consent.)',
    value: DocumentationDeliveryMethod.email,
  },
  { label: 'Collect from the nearest branch', value: DocumentationDeliveryMethod.collectFromNearestBranch },
  {
    label:
      "Via post (this option may add 10 days to the process to allow time for posting, it's not recommended for urgent settlements)",
    value: DocumentationDeliveryMethod.post,
  },
];

export const DocumentDeliveryMethod = ({ brokerInterviewsGuarantorIndex }: BrokerInterviewsGuarantorEntityIndex) => {
  const [formValues] = useFormValues();

  return (
    <FunnelGrid mt="md" mb="lg">
      <FunnelGridUnit size={1 / 2}>
        Confirm the delivery method for documents:
        <br />
        <br />
        Once the loan is approved, what is your preferred method for the guarantee documents to be issued to you?
      </FunnelGridUnit>
      <FunnelGridUnit size={1 / 2}>
        <RadioButtonsField
          name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_DOCUMENTATION_DELIVERY_METHOD(brokerInterviewsGuarantorIndex)}
          radios={OPTIONS}
          size="sm"
          isBoxed={false}
          selectedValue={get(
            formValues,
            FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_DOCUMENTATION_DELIVERY_METHOD(brokerInterviewsGuarantorIndex)
          )}
          isOptional
        />
      </FunnelGridUnit>
    </FunnelGrid>
  );
};
